import React, { useEffect, useState } from 'react'
import { CircularProgress, Divider, Grid, Typography } from '@material-ui/core'
import { useReportService } from 'hooks/useReportService'
import { ExibirArquivo } from 'components/ExibirArquivo'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

import useStyles from './styles'

export const DetailPanel = (props) => {
  const { idReportSelecionado } = props
  moment.locale('pt-br', localization)
  const reportService = useReportService()
  const [processandoReport, setProcessandoReport] = useState(false)
  const [report, setReport] = useState(null)

  const classes = useStyles()

  useEffect(() => {
    const fetchReport = async () => {
      const response = await reportService.listarReportAsync(
        idReportSelecionado,
        setProcessandoReport
      )
      setReport(response)
    }

    if (idReportSelecionado) {
      fetchReport()
    }
  
  }, [idReportSelecionado])

  return (
    <div>
      {processandoReport || !report ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container className={classes.container} spacing="2">
          <Grid item md={12} sm={12} xs={12}>
            <Typography variant="h6">Descrição</Typography>
            <Typography>{report.descricao}</Typography>
          </Grid>
          <Grid item>
            <Divider />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Typography variant="h6">Arquivo</Typography>
            {report?.arqs?.map((arquivo) => (
              <Grid className={classes.item} item md={2} sm={4} xs={7}>
                <ExibirArquivo id={arquivo.id} rotaLoadFile="/arquivo/report" />
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
    </div>
  )
}
